module.exports = __webpack_public_path__ + "static/media/1.65ee1a69.jpg";